import { Drawer, makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import React, { useMemo } from 'react';
import { useViewer } from 'src/hooks/use-viewer';
import { LogoYugo } from '~svg-components';
import { useSideNavigationOpenContext } from '../side-navigation-context';
import ListSlide from './list-slide';

const useStyles = makeStyles((theme) => ({
  drawer: {
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },

  drawerOpen: {
    width: 248,
    paddingBottom: 64,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },

  drawerClose: {
    width: 64,
    overflowX: 'hidden',
    paddingBottom: 64,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },

  logoMenuOpen: {
    marginTop: 24,
    marginBottom: 16,
    marginLeft: 32,
    '& > svg': { width: 32, height: 32 },
  },

  logoMenuClose: {
    marginTop: 16,
    marginLeft: 20,
    marginBottom: 16,
    '& > svg': { width: 24, height: 24 },
  },
}));

export default function Slide() {
  const classes = useStyles();
  const { currentRole } = useViewer();
  const { isSideNavigationOpen } = useSideNavigationOpenContext();

  const permissions = currentRole?.role.permissions;

  const sortedPermissions = useMemo(() => {
    return permissions.sort((current, next) => {
      const orderRules = [
        'dashboard',
        'inventory',
        'in-residence',
        'booking',
        'student',
        'partners',
        'nominations',
        'approval-center',
        'settings',
      ];
      return orderRules.indexOf(current.slug) - orderRules.indexOf(next.slug);
    });
  }, [permissions]);

  return (
    <Drawer
      variant="permanent"
      className={classNames(classes.drawer, {
        [classes.drawerOpen]: isSideNavigationOpen,
        [classes.drawerClose]: !isSideNavigationOpen,
      })}
      classes={{
        paper: classNames({
          [classes.drawerOpen]: isSideNavigationOpen,
          [classes.drawerClose]: !isSideNavigationOpen,
        }),
      }}
      id="for-release-hint-right-side"
    >
      <div
        className={classNames(classes.logo, {
          [classes.logoMenuOpen]: isSideNavigationOpen,
          [classes.logoMenuClose]: !isSideNavigationOpen,
        })}
      >
        <LogoYugo />
      </div>

      {sortedPermissions?.map((item) => (
        <ListSlide key={item.name} {...item} />
      ))}
    </Drawer>
  );
}
